import { useState, useEffect } from "react";
import App from "./App";
import Login from "./components/Login";
import { checkSession, logout as apiLogout } from "./services/api";

const TOKEN_KEY = "emk-auth-token";
const USER_KEY = "emk-auth-user";
const THEME_KEY = "emk-theme";

export default function AppRoot() {
  const [checking, setChecking] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  const [theme, setTheme] = useState(() => localStorage.getItem(THEME_KEY) || "dark");

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem(THEME_KEY, theme);
  }, [theme]);

  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      setChecking(false);
      return;
    }
    checkSession()
      .then((r) => setCurrentUser(r.data.kullanici_adi))
      .catch(() => {
        localStorage.removeItem(TOKEN_KEY);
        localStorage.removeItem(USER_KEY);
      })
      .finally(() => setChecking(false));
  }, []);

  function toggleTheme() {
    setTheme((t) => (t === "dark" ? "light" : "dark"));
  }

  function handleLoginSuccess(data) {
    localStorage.setItem(TOKEN_KEY, data.token);
    localStorage.setItem(USER_KEY, data.kullanici_adi);
    setCurrentUser(data.kullanici_adi);
  }

  function handleLogout() {
    apiLogout().catch(() => {});
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    setCurrentUser(null);
  }

  if (checking) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", background: "var(--bg-page)", color: "var(--text-muted)", fontSize: 14 }}>
        ⏳ Yükleniyor...
      </div>
    );
  }

  if (!currentUser) {
    return <Login onSuccess={handleLoginSuccess} theme={theme} onToggleTheme={toggleTheme} />;
  }

  return <App currentUser={currentUser} onLogout={handleLogout} theme={theme} onToggleTheme={toggleTheme} />;
}
